import { render, staticRenderFns } from "./SideCart.vue?vue&type=template&id=1780d555&scoped=true"
import script from "./SideCart.vue?vue&type=script&lang=js"
export * from "./SideCart.vue?vue&type=script&lang=js"
import style0 from "./SideCart.vue?vue&type=style&index=0&id=1780d555&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1780d555",
  null
  
)

export default component.exports